import React, { useContext } from 'react'
import ReportingTable from './ReportingTable'
import { Link } from 'react-router-dom'
import { FaPlus } from 'react-icons/fa'
import { ReportingContext } from '../../wrappers/ReportingContext'

const NewReportButton = () => {
    const { createReport } = useContext(ReportingContext)

    return (
        <button className="button is-info" onClick={() => createReport()}>
            <span className="icon is-small">
                <FaPlus />
            </span>
            <span>New Report</span>
        </button>
    )
}

const ReportingDashboard = () => {
    return (
        <>
            <div className="columns returnLinkHeaderWrapper">
                <div className="column">
                    <p className="is-2 ">
                        <Link to="/">
                            <span className="icon">
                                <i className="fa fa-chevron-left" />
                            </span>
                            Return to Dashboard Directory
                        </Link>
                    </p>
                </div>
            </div>
            <div className="section reportTableSection">
                <h1 className={'title is-3 reportTableTitle '}>
                    <span>{'Reporting Menu'}</span>
                    <span>
                        <NewReportButton />
                    </span>
                </h1>
                <div className="level-right">
                    <div className="level-item"></div>
                </div>
                <div className="reportingDashboardWrapper">
                    <ReportingTable />
                </div>
            </div>
        </>
    )
}

export default ReportingDashboard
